// extracted by mini-css-extract-plugin
export default {"Container":"Social_Container__H9fHc","Icon":"Social_Icon__+W+s5","Wrapper":"Social_Wrapper__8MmHZ","Copyright":"Social_Copyright__cBUV+"};